import React from 'react';
import { Link } from 'react-router-dom';

import settings from 'config/constants';

const products = settings.PRODUCTS;

const { path } = products.RISK_WEEKLY_REPORT;

/**
 * Navigation for the standalone Risk Weekly Report.
 *
 * `permission: 'show'` renders the item unconditionally — MenuBar treats that value as an
 * explicit bypass. The report's server-side permission is not registered yet, and gating on an
 * unknown permission name would hide the feature entirely rather than fail visibly.
 * Swap to the real permission once it is added to the backend permission set.
 */
export default [
  {
    id: `/${path}`,
    title: <Link className="route_link" to={`/${path}`}>Live Dashboard</Link>,
    icon: 'bc-icon-dashboard',
    permission: 'show'
  }
];
